export function toggleClass(element, ...classes) {
  if (element) {
    classes.forEach(cls => element.classList.toggle(cls));
  }
}

export function addClass(element, ...classes) {
  if (element) {
    classes.forEach(cls => element.classList.add(cls));
  }
}

export function removeClass(element, ...classes) {
  if (element) {
    classes.forEach(cls => element.classList.remove(cls));
  }
}
